/**
 * Famílias de espaço aéreo que o app renderiza com estilo/rótulo próprios. O
 * dataset pode trazer tipos fora deste union (novas classificações AIS servidas
 * pelo servidor); esses fluem pelo app como strings cruas e são tratados
 * genericamente — ver `airspaceTypeRegistry`. Mantenha este union em sincronia
 * com o registry e com `MapLayerStateProps`.
 */
type AirspaceType =
  | 'adiz'
  | 'afis'
  | 'atz'
  | 'cta'
  | 'ctaSector'
  | 'ctr'
  | 'freeRouteAreas'
  | 'fis'
  | 'fir'
  | 'firSector'
  | 'fiz'
  | 'fcaAd'
  | 'fca'
  | 'fcaReh'
  | 'suaDangerous'
  | 'suaProhibited'
  | 'suaRestricted'
  | 'tma'
  | 'tmaSector'

// Fonte única do conjunto conhecido, compartilhada pelo domínio (ex.: toggles do
// MapLayerState) e pela apresentação (o registry de tipos). A ordem importa: é a
// ordem de renderização no mapa e, portanto, o empilhamento (FIR/TMA amplos por
// baixo, CTR/ATZ menores por cima). CTA/Setor de CTA ficam ao lado da TMA como
// áreas de controle irmãs.
const KNOWN_AIRSPACE_TYPES: AirspaceType[] = [
  'adiz',
  'afis',
  'fir',
  'firSector',
  'tma',
  'tmaSector',
  'cta',
  'ctaSector',
  'ctr',
  'atz',
  'fis',
  'fiz',
  'freeRouteAreas',
  'fca',
  'fcaReh',
  'fcaAd',
  'suaDangerous',
  'suaProhibited',
  'suaRestricted'
]

const isKnownAirspaceType = (type: string): type is AirspaceType => (KNOWN_AIRSPACE_TYPES as string[]).includes(type)

export type { AirspaceType }
export { isKnownAirspaceType, KNOWN_AIRSPACE_TYPES }
